module.exports = __webpack_public_path__ + "static/media/warning-circle-tk.0ebd6d5b.svg";